var map = {
	"./colis/colis_4.jpg": 5531,
	"./foret/foret_4.jpg": 131,
	"./genie/genie_4.jpg": 8356,
	"./porte/porte_4.jpg": 8882,
	"./vaisseau/vaisseau_4.jpg": 3721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7659;